// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"98":"1e87da896a500280","1895":"9dc40731cb011239","3029":"cfea190b4193676c","3641":"48f3bb8d51cc3df4","3784":"ae374cdc04f835e4","3978":"30cb2175749290c1","4598":"09c53e45d52a3736","7165":"f02b4b99363b0e08","7478":"f320508f10dc1500","7532":"84968a1f9d9c68c9"}[chunkId] + ".js";
};